import ComingSoonBanner from "./components/ComingSoonBanner";
import KpiGrid from "./components/KpiGrid";
import RevenueCharts from "./components/RevenueCharts";
import TransactionsTable from "./components/TransactionsTable";
import { recentTransactionsMock } from "./variables/revenueMock";
import { useLanguage } from "context/LanguageContext";

const RevenueManagement = () => {
  const { t } = useLanguage();

  return (
    <div className="mt-5 grid h-full grid-cols-1 gap-5">
      <div className="flex flex-col gap-1">
        <h2 className="text-2xl font-bold text-ink">
          {t("nav.revenue")}
        </h2>
        <p className="text-sm text-ink-muted">
          {t("revenue.pageSubtitle")}
        </p>
      </div>

      <ComingSoonBanner />

      <KpiGrid />

      <RevenueCharts />

      <TransactionsTable rows={recentTransactionsMock} />
    </div>
  );
};

export default RevenueManagement;
